import { render, staticRenderFns } from "./TiposDevolucao.vue?vue&type=template&id=924b5c6c&scoped=true&"
import script from "./TiposDevolucao.vue?vue&type=script&lang=js&"
export * from "./TiposDevolucao.vue?vue&type=script&lang=js&"
import style0 from "./TiposDevolucao.vue?vue&type=style&index=0&id=924b5c6c&scoped=true&lang=css&"
import style1 from "./TiposDevolucao.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924b5c6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
